// 小程序全部分类页面
export default {
  routes: [
    {
      path: '/cashOutGuide',
      name: 'cashOutGuide',
      meta: {
        desc: '旧物折现购',
        pageId: 'O4333'
        // level: 2,
        // isAutoPV: false
      },
      component: () =>
        import(/* webpackChunkName: "AllCategory" */ '../views/cashOut/cashOutGuide/index.vue')
    },
    {
      path: '/cashOutDetail',
      name: 'cashOutDetail',
      meta: {
        desc: '折现拿钱',
        pageId: 'M9202'
        // level: 2,
        // isAutoPV: false
      },
      component: () =>
        import(/* webpackChunkName: "AllCategory" */ '../views/cashOut/cashOutDetail/index.vue')
    }
  ]
}
